import { render, staticRenderFns } from "./layout-d2admin.vue?vue&type=template&id=3985e164"
import script from "./layout-d2admin.vue?vue&type=script&lang=js"
export * from "./layout-d2admin.vue?vue&type=script&lang=js"
import style0 from "./layout-d2admin.vue?vue&type=style&index=0&id=3985e164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports